
import { CreateElement, RenderContext, VNode } from 'vue';

function createStar(h: CreateElement, size: number, val: number): VNode {
    return h('div', {
        style: {
            height: size + 'px',
            width: size + 'px',
            '--val': val + '%',
        }
    });
}

export default {
    functional: true,
    props: {
        rating: {
            type: Number,
            required: true,
        },
        size: {
            type: Number,
            default: 15,
        },
    },
    render(h: CreateElement, ctx: RenderContext) {

        const childs: VNode[] = [];

        let filled = Math.floor(ctx.props.rating),
            fraction = ctx.props.rating - filled;

        for (let i = 0; i < filled; i++) {
            childs.push(createStar(h, ctx.props.size, 100));
        }

        if (fraction > 0) {
            childs.push(createStar(h, ctx.props.size, Math.round(fraction * 100)));
            filled++;
        }

        for (let i = filled; i < 5; i++) {
            childs.push(createStar(h, ctx.props.size, 0));
        }

        return h('div', {
            class: 'rating-stars'
        }, childs);
       
    }
}
